import { render, staticRenderFns } from "./standardGroupingReports.vue?vue&type=template&id=8a1bb23c&scoped=true"
import script from "./standardGroupingReports.vue?vue&type=script&lang=js"
export * from "./standardGroupingReports.vue?vue&type=script&lang=js"
import style0 from "./standardGroupingReports.vue?vue&type=style&index=0&id=8a1bb23c&prod&lang=css&scoped=true"
import style1 from "./standardGroupingReports.vue?vue&type=style&index=1&id=8a1bb23c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1bb23c",
  null
  
)

export default component.exports